import { useTranslation } from 'react-i18next';
import {
  Button,
  ResultContent,
  ModalComponentWrapper,
} from '@/shared/components';
import { useModalStore } from '@/shared/lib';
import { EXCHANGE_RESULT_VARIANTS, type ExchangeResultVariant } from './types';

const useExchangeResult = (
  variant: ExchangeResultVariant = EXCHANGE_RESULT_VARIANTS.PAGE
) => {
  const { t } = useTranslation();
  const { showDialogComponent, closeDialog } = useModalStore();
  const isSection = variant === EXCHANGE_RESULT_VARIANTS.SECTION;

  const goToSuccessScreen = () => {
    showDialogComponent({
      component: (
        <ModalComponentWrapper>
          <ResultContent
            isSuccess
            title={t('exchange.successTitle')}
            description={t('exchange.successDescription')}
            showButton={false}
            className="h-auto">
            <Button
              size="lg"
              variant="secondary"
              onClick={() => {
                closeDialog();
              }}
              className={
                isSection ? 'w-full headline4' : 'w-full headline4 mb-[1.6rem]'
              }>
              {t('exchange.exchangeMore')}
            </Button>
            {!isSection && (
              <Button
                size="lg"
                variant="secondary"
                onClick={() => {
                  closeDialog();
                  window.location.href = '/';
                }}
                className="w-full headline4">
                {t('exchange.goToMain')}
              </Button>
            )}
          </ResultContent>
        </ModalComponentWrapper>
      ),
    });
  };

  const goToErrorScreen = () => {
    showDialogComponent({
      component: (
        <ModalComponentWrapper>
          <ResultContent
            isSuccess={false}
            onClick={() => {
              closeDialog();
            }}
            title={t('exchange.errorTitle')}
            description={t('exchange.errorDescription')}
            buttonText={t('common.close')}
            buttonVariant="secondary"
          />
        </ModalComponentWrapper>
      ),
    });
  };

  const goToNetworkErrorScreen = (onRefresh?: () => void) => {
    showDialogComponent({
      component: (
        <ModalComponentWrapper>
          <ResultContent
            isSuccess={false}
            onClick={() => {
              closeDialog();
              if (isSection) {
                onRefresh?.();
                return;
              }
              window.location.reload();
            }}
            title={t('exchange.networkErrorTitle')}
            description={t('exchange.networkErrorDescription')}
            buttonText={t('exchange.refresh')}
            buttonVariant="secondary"
          />
        </ModalComponentWrapper>
      ),
    });
  };

  return {
    goToSuccessScreen,
    goToErrorScreen,
    goToNetworkErrorScreen,
  };
};

export { useExchangeResult };
